export const environment = {
  production: true,
  api_url: 'https://ebopro.app',
  googleMapApiKey: 'AIzaSyDCUwa2ocdg1xKTvzCMO8gHBHgKVscrg6E'
};
